//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HTTP from "@/http-common";
// import Fornac from "@/components/Fornac";
import FshiftSignalStructure from "@/components/FshiftSignalStructure";

export default {
    data: function() {
        return {
            organism: {
                prm_dict: {
                    taxonomy: [],
                },
            },
            subunitsTableHeaders: [
                { text: "Location", value: "location", width: "1%" },
                { text: "S", value: "s", width: "1%" },
                { text: "Pathway", value: "pathway", width: "1%" },
                { text: "Name", value: "name", width: "1%" },
                { text: "Len", value: "len", width: "1%" },
                { text: "FS", value: "fs", width: "1%", sortable: false },
                { text: "Gene", value: "gene", width: "1%" },
                { text: "Group", value: "group", width: "1%" },
                {
                    text: "E-value",
                    value: "evalue",
                    width: "1%",
                    sortable: true,
                },
                {
                    text: "Description",
                    value: "description",
                    width: "15%",
                    sortable: false,
                },
            ],
            pathwayGenesCountHeaders: [
                { text: "Name", value: "name", width: "1%" },
                { text: "#Genes", value: "count", width: "1%" },
            ],
        };
    },
    components: {
        // Fornac,
        FshiftSignalStructure,
    },
    computed: {
        fshifts() {
            function updateData(fshift) {
                let new_fshift = Object.assign(fshift);
                let fornacColorsStr = ``;
                if (new_fshift.signal) {
                    let seq = new_fshift.signal.seq;
                    if (new_fshift.signal) {
                        const stop_codon_coord =
                            new_fshift.signal.stop_codon_coord;
                        const stopCodonColour = "OrangeRed";
                        if (stop_codon_coord) {
                            fornacColorsStr += ` ${stop_codon_coord[0] + 1}-${
                                stop_codon_coord[1]
                            }:${stopCodonColour}`;
                            seq =
                                seq.slice(0, stop_codon_coord[0]) +
                                `<span style="background-color: ${stopCodonColour}">` +
                                seq.slice(
                                    stop_codon_coord[0],
                                    stop_codon_coord[1]
                                ) +
                                `</span>` +
                                seq.slice(stop_codon_coord[1]);
                        }
                        const polyAColour = "DodgerBlue";
                        const poly_a_coord = new_fshift.signal.poly_a_coord;
                        if (poly_a_coord) {
                            let poly_a_coord = new_fshift.signal.poly_a_coord;
                            fornacColorsStr += ` ${poly_a_coord[0] + 1}-${
                                poly_a_coord[1]
                            }:${polyAColour}`;
                            seq =
                                seq.slice(0, poly_a_coord[0]) +
                                `<span style="background-color: ${polyAColour}">` +
                                seq.slice(poly_a_coord[0], poly_a_coord[1]) +
                                `</span>` +
                                seq.slice(poly_a_coord[1]);
                        }
                    }
                    new_fshift.signal["coloredSeq"] = seq;
                    new_fshift.signal["fornacColorsStr"] = fornacColorsStr;
                }
                return new_fshift;
            }
            let new_frameshifts = this.organism.fshift_set.map(updateData);
            console.log(new_frameshifts);
            return new_frameshifts;
        },

        taxonomyBreadcrumbs() {
            return this.organism.prm_dict.taxonomy.map((tax) => {
                return { text: tax };
            });
        },
        subunitsTableItems() {
            return this.organism.chel_subunit_feat_set.map((feat) => {
                return {
                    location: feat.prm_dict.location_str,
                    s: feat.prm_dict.chel_subunit,
                    pathway: feat.prm_dict.chel_pathway,
                    name: feat.name,
                    len: feat.prm_dict.translation_len,
                    fs: feat.frameshift_len,
                    gene: feat.prm_dict.chel_gene,
                    group: feat.prm_dict.chel_gene_group,
                    evalue: feat.prm_dict.chel_evalue,
                    description: feat.descr,
                    hrefNcbiGeneTrack: `https://www.ncbi.nlm.nih.gov/nuccore/${
                        feat.seq_id
                    }?report=graph&from=${feat.start + 1}&to=${feat.end}`,
                };
            });
        },
        b12PathwayGenesCountItems() {
            return this.organism.b12_genes_count.map((gene_count) => {
                return {
                    name: gene_count[0],
                    count: gene_count[1],
                };
            });
        },
        chlPathwayGenesCountItems() {
            return this.organism.chl_genes_count.map((gene_count) => {
                return {
                    name: gene_count[0],
                    count: gene_count[1],
                };
            });
        },
    },
    methods: {
        getColor(count, pathway) {
            var colors;
            if (pathway == "b12") {
                colors = ["blue lighten-4", "blue lighten-2"];
            } else {
                colors = ["green lighten-4", "green lighten-2"];
            }
            if (count == 1) return colors[0];
            else if (count > 1) return colors[1];
            else return "white";
        },
    },
    mounted: function() {
        HTTP.get(`organisms/` + this.$route.params.id)
            .then((response) => {
                // JSON responses are automatically parsed.
                console.log(response.data);
                this.organism = response.data;
            })
            .catch((error) => {
                console.warn(error);
            });
         window.scrollTo(0, 0)
    },
};
